import store from '../store/store';
import { action } from 'satcheljs/lib/legacy';

export default action('addSessionMaskedRecipient')(async function addSessionMaskedRecipient(
    maskedEmailAddress: string
) {
    store.sessionMaskedRecipients[maskedEmailAddress] = true;
});
